import { CaretDownOutlined } from '@ant-design/icons'
import EmojiPicker from 'emoji-picker-react'
import React, { useEffect, useRef, useState } from 'react'
const EmojiDropDown = ({
  value, // controlled
  defaultValue = '✨', // 필수 값
  backgroundColor = 'transparent',
  onChange,
  disabled = false,
}) => {
  const [open, setOpen] = useState(false)
  const [internalEmoji, setInternalEmoji] = useState(defaultValue)
  const wrapperRef = useRef(null)

  const selectedEmoji = value ?? internalEmoji
  // 외부 클릭 닫기
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  const handleSelect = (emoji) => {
    if (value === undefined) {
      setInternalEmoji(emoji)
    }
    onChange?.(emoji)
    setOpen(false)
  }

  return (
    <div ref={wrapperRef} style={{ position: 'relative' }}>
      <button
        type="button"
        disabled={disabled}
        onClick={() => setOpen((prev) => !prev)}
        style={{
          ...styles.selectedButton,
          opacity: disabled ? 0.5 : 1,
          cursor: disabled ? 'not-allowed' : 'pointer',
        }}
      >
        <div
          style={{
            ...styles.emojiBackground,
            background: backgroundColor,
          }}
        >
          <div>{selectedEmoji}</div>
        </div>

        <CaretDownOutlined
          style={{
            fontSize: '14px',
            color: '#80807D',
            marginLeft: '6px',
            transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
            transition: 'transform 0.2s',
          }}
        />
      </button>

      {open && !disabled && (
        <div style={styles.dropdown}>
          <EmojiPicker
            onEmojiClick={(emojiData) => handleSelect(emojiData.emoji)}
            searchDisabled
            previewConfig={{ showPreview: false }}
            theme="dark"
            emojiStyle="apple"
          />
        </div>
      )}
    </div>
  )
}

export default EmojiDropDown

const styles = {
  selectedButton: {
    fontSize: '16px',
    cursor: 'pointer',
    background: 'transparent',
    border: '1px solid #E1E1DE',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '48px',
    padding: '0 12px',
    borderRadius: '8px',
  },
  dropdown: {
    position: 'absolute',
    top: '60px',
    zIndex: 9999,
  },
  emojiBackground: {
    width: '28px',
    height: '28px',
    minWidth: '28px',
    minHeight: '28px',
    borderRadius: '50%',
    background: '#191A1C',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '0.9rem',
    lineHeight: 1,
  },
}
